import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const ProtectedRoute = ({ children, role }) => {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center" data-testid="auth-loading">
        <div className="text-[#09637E] text-lg font-bold">جارٍ التحميل...</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (role && !(Array.isArray(role) ? role : [role]).includes(user.role)) {
    return <Navigate to={user.role === "admin" ? "/admin" : user.role === "employee" ? "/reservations" : "/dashboard"} replace />;
  }
  return children;
};

export default ProtectedRoute;
